class AllBeansFilterToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.panels = document.querySelectorAll(
      `[data-all-beans-panel="${this.dataset.sectionId}"]`
    );
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', String(!isOpen));
    this.panels.forEach((panel) => panel.classList.toggle('is-open', !isOpen));
  }
}

customElements.define('all-beans-filter-toggle', AllBeansFilterToggle);
